import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { reviews } from '@/mocks/reviews';

export default function About() {
  const { t, i18n } = useTranslation();
  const isDe = i18n.language === 'de';

const stats = [
  { value: 500, suffix: "+", label: t("about_stats_tours") },
  { value: 10000, suffix: "+", label: t("about_stats_guests") },
  { value: 15, suffix: "+", label: t("about_stats_years") },
  { value: 20, suffix: "+", label: t("about_stats_guides") },
];

  const values = [
    { icon: 'ri-map-pin-line', title: t('about_expertise'), text: t('about_expertise_text') },
    { icon: 'ri-shield-check-line', title: t('about_safety'), text: t('about_safety_text') },
    { icon: 'ri-calendar-check-line', title: t('about_flexibility'), text: t('about_flexibility_text') },
    { icon: 'ri-user-heart-line', title: t('about_personal'), text: t('about_personal_text') },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-28 md:pt-32">
        {/* Hero */}
        <section className="bg-primary-900 py-12 md:py-16">
          <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20 text-center">
            <p className="text-accent-400 text-xs tracking-[0.3em] uppercase mb-3">Yallabina Tours</p>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">{t('about_title')}</h1>
            <p className="text-background-300 text-sm md:text-base max-w-2xl mx-auto">{t('about_subtitle')}</p>
          </div>
        </section>

        {/* Story */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="flex-1 lg:pr-8">
  <p className="text-accent-600 text-xs tracking-[0.25em] uppercase font-semibold mb-4">
    Yallabina Tours
  </p>

  <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight text-foreground-900 mb-5">
    {t('about_story')}
  </h2>

  <div className="w-16 h-[2px] bg-accent-500 mb-6" />

  <p className="text-foreground-600 text-base md:text-lg leading-8 mb-8 max-w-2xl">
    {t('about_story_text')}
  </p>

  <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
    {t('about_mission')}
  </h3>

  <p className="text-foreground-600 text-base leading-8 max-w-2xl">
    {t('about_mission_text')}
  </p>
</div>
              <div className="flex-1">
                <img
                 src="./images/about-us/about-collage.jpg"
                  alt="Yallabina Tours Team"
                  className="w-full rounded-sm"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section
  
  className="py-10 bg-accent-500"
>
          <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat) => (
  <div key={stat.label} className="text-center">
   <span className="font-heading text-3xl md:text-4xl font-bold text-primary-950">
  {stat.value}
  {stat.suffix}
</span>

    <span className="text-sm text-primary-800 font-medium">
      {stat.label}
    </span>
  </div>
))}
    </div>
  </div>
        </section>

        {/* Values */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {values.map((v) => (
                <div key={v.title} className="bg-background-50 border border-background-200 rounded-sm p-6">
                  <div className="w-10 h-10 bg-accent-100 rounded-sm flex items-center justify-center mb-4">
                    <i className={`${v.icon} text-accent-600 text-lg`} />
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{v.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 lg:px-12 xl:px-20">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8">{t('reviews_title')}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {reviews.slice(0, 6).map((rev) => (
                <div key={rev.id} className="bg-background-50 border border-background-200 rounded-sm p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-accent-500 rounded-full flex items-center justify-center text-primary-950 font-bold text-sm">
                      {rev.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{rev.name}</p>
                      <p className="text-xs text-foreground-500">{rev.location}</p>
                    </div>
                  </div>
                  <div className="flex gap-0.5 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className={`ri-star-fill text-xs ${i < rev.rating ? 'text-accent-500' : 'text-foreground-300'}`} />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{isDe ? rev.text_de : rev.text_en}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}